"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iframeTemplate = void 0;
function findMatches(regex, str, matches) {
    const res = regex.exec(str);
    if (res) {
        matches.push(res);
        findMatches(regex, str, matches);
    }
    return matches;
}
const iframeTemplate = (template, replace) => {
    const extractedKeys = /<([\dA-z-]+)>/g;
    const allMatches = findMatches(extractedKeys, template, []);
    let str = template;
    for (const matches of allMatches) {
        if (matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 1) {
            const [pattern, key] = matches;
            const text = replace[key];
            if (text) {
                str = str.replace(pattern, text);
            }
        }
    }
    return str;
};
exports.iframeTemplate = iframeTemplate;
//# sourceMappingURL=iframeTemplate.js.map